import React from 'react';

import { NitroHeading, NitroParagraph } from 'nitro-components';

import Header from '../../../../components/layouts/Header';

const QuestionBanner = () => (
  <Header margin="32px 0" lineHeight={32}>
    <NitroHeading align="center" size="1" label="New corporate Quote" />
    <NitroParagraph align="center" size="3">
      Please complete the following questions to get started
    </NitroParagraph>
  </Header>
);

export default QuestionBanner;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/QuestionBanner.js